module.exports = __webpack_public_path__ + "static/media/arrow-link-up-collapse-small_white.b0da5480.svg";